import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Insegni chimica nella scuola secondaria di secondo grado.', 'Cerchi lezioni strutturate, visuali e pronte da utilizzare.', 'Vuoi un sistema completo, non altri file da organizzare.', 'Vuoi aiutare gli studenti a comprendere e applicare i concetti.', 'Hai bisogno di materiali per spiegazione, esercitazione, laboratorio, ripasso e valutazione.', 'Insegni in presenza, online o in modalità mista.', 'Vuoi ridurre il tempo di preparazione senza rinunciare al rigore scientifico.'];
const notForYou = ['Stai cercando un videocorso o una certificazione accademica.', 'Preferisci creare ogni risorsa completamente da zero.', 'Hai bisogno di un programma personalizzato esclusivamente per il tuo istituto.', 'Stai cercando lezioni private o consulenza individuale continuativa.', 'Cerchi un prodotto fisico già stampato e spedito a casa.'];
export function AudienceSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-21" data-mp="149hjvy95ke1y">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-22" data-mp="zbzm940l5l99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-cobalt/20 bg-[#EEF4FF] p-6 sm:p-8" data-id="element-23" data-mp="zdsq6bjtdrdk">
          <h3 className="mb-6 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-24" data-mp="llmdizfve2iv">
            ✅ CHIMICA VISIVA™ fa per te se…
          </h3>
          <ul className="space-y-4" data-id="element-25" data-mp="blvfins3p5e1">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-26" data-mp="bnyg21qvqgx0">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-27" data-mp="7luzwzt9mo5e">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-28" data-mp="25xtpwt25c7bi" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-29" data-mp="21wqbmazqyjce">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-30" data-mp="43ntnyhsrlnl">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-31" data-mp="i3gjzspevzv1">
            ❌ CHIMICA VISIVA™ non fa per te se…
          </h3>
          <ul className="space-y-4" data-id="element-32" data-mp="n0ozflj6dpsl">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-33" data-mp="90xjhf93lzby">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-34" data-mp="e0ackhqkc2mz">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="2tr51l8uvszm2" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-36" data-mp="2yrsopjfzowb0">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}